import "../App.css";
import Typewriter from 'typewriter-effect';
import { Link } from 'react-scroll'
export function Intro() {

    return <div className="intro">
        <div className="centering" id="name_head">Ramendra Vikram Singh Parihar</div>
        <div className="centering" id="tag_line"><Typewriter
            options={{
                loop: true,
            }}
            onInit={(typewriter) => {
                typewriter.pauseFor(2500)
                    .typeString('Full Stack Web Developer')
                    .pauseFor(2500)
                    .deleteAll()
                    .typeString('Passionate about changing the world with technology.')
                    .pauseFor(2500)
                    .start();
            }}
        /></div>
        <div id="icons">
            <a target="_blank" rel="noreferrer" href="https://github.com/rv-vikram"><i class="fab fa-github"></i></a>
            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/itsrvsingh/"><i class="fab fa-linkedin"></i></a>
            <a target="_blank" rel="noreferrer" href="https://instagram.com/_its.rav_"><i class="fab fa-instagram"></i></a>
            <a target="_blank" rel="noreferrer" href="https://twitter.com/ramendravsingh"><i class="fab fa-twitter"></i></a>
        </div>
        <div id="more_about"><a href="#about"><Link id="more" activeClass="active" className="test1" to="Abouts" spy={true} smooth={true} duration={500} >More About Me</Link></a></div>
    </div>
}